import { CheckCircle } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from "material-react-table";
import { useRef, useState } from "react";
import { dateTimeAccesor } from "../../../commons/table/columns/accesors";
import { localization, tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const NovedadesTable = ({
  setSelectedRows,
  handleSubmitSelected,
  data,
  loading,
  fetchData,
  noRefresh,
}) => {

  const [rowSelection, setRowSelection] = useState({});
  const columns = [
    {
      header: "Art",
      accessorKey: "art",
      enableColumnFilter: false,
    },
    {
      header: "Fecha Hora Ingreso Novedad",
      accessorKey: "fechaHoraIngresoNovedad",
      accessorFn: dateTimeAccesor("fechaHoraIngresoNovedad"),
    },
    { header: "Siniestro", accessorKey: "historiaClinica" },
    { header: "Documento", accessorKey: "documento", },
    { header: "Trabajador", accessorKey: "trabajador", },
    { header: "Empleador", accessorKey: "empleador" },
    { header: "Prestador", accessorKey: "proveedor" },
    {
      header: "Fecha Formulario",
      accessorKey: "fechaFormulario",
      accessorFn: dateTimeAccesor("fechaFormulario"),
      filterFn: "includesString"
    },
    { header: "Formulario", accessorKey: "formulario" },
    {
      header: "Fecha Procesado",
      accessorKey: "fechaProcesado",
      accessorFn: dateTimeAccesor("fechaProcesado"),
      filterFn: "includesString"
    },
    {
      header: "Nro Transacción",
      accessorKey: "nroTransaccionLocal",
      filterFn: "includesString",
    },
    {
      header: "Inicio Proceso",
      accessorKey: "InicioProceso",
      filterVariant: "select",
      filterSelectOptions: [
        { text: "Todos", value: "" },
        { text: "Sí", value: "si" },
        { text: "No", value: "no" },
      ],
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true;
        const cellValue = !!row.getValue(columnId);
        if (filterValue === "si") return cellValue === true;
        if (filterValue === "no") return cellValue === false;
        return true;
      },
      Cell: ({ row }) => {
        return row.original.inicioProceso ? "Sí" : "No";
      },

    }
  ];

  const [selectedRows, setSelectedRowsState] = useState([]);
  const tableRef = useRef();

  return (
    <div >
      <MaterialReactTable
        {...tableConfig}
        tableRef={tableRef} // Referencia a la tabla
        positionToolbarAlertBanner="top"
        onRowSelectionChange={setRowSelection}
        enableSelectAll
        enableRowSelection
        columns={columns}
        defaultColumn={{
          muiFilterTextFieldProps: {
            placeholder: '',
          },
        }}
        renderTopToolbarCustomActions={
          Object.keys(rowSelection).length > 0 ? undefined : ({ table }) => {
            return (
              <Box m={0.5}>
                <TitleContainer
                  title="Novedades"
                  noRefresh={noRefresh}
                  fetchData={fetchData}
                />
              </Box>
            )
          }}
        data={data}
        state={{ isLoading: loading, rowSelection }}
        renderToolbarInternalActions={({ table }) => {
          const selectedRows = table?.getSelectedRowModel()?.rows?.map((row) => row.original);
          if (selectedRows?.length > 0) {
            return (
              <Tooltip title="Reenviar Novedades">
                <IconButton
                  sx={{ color: "secondary.main" }}
                  onClick={() => {
                    handleSubmitSelected(selectedRows);
                    table.resetRowSelection();
                  }}>
                  <CheckCircle />
                </IconButton>
              </Tooltip>
            )
          }
          return (
            <>
              <MRT_ToggleFiltersButton table={table} />
              <MRT_ToggleDensePaddingButton table={table} />
              <MRT_ToggleFullScreenButton table={table} />
            </>
          )
        }}

        muiTableBodyCellProps={
          localization.cells
        }
        onSelectionChange={(rows) => {
          setSelectedRows(rows); // Actualizar filas seleccionadas en el padre
          setSelectedRowsState(rows); // Actualizar filas seleccionadas localmente
        }}
        layoutMode="grid"
      />
    </div>
  );
};

export default NovedadesTable;